import { FormControl, ValidationErrors, Validators } from '@angular/forms';

const validCharacters = /^\d{6}$/;

export class PinValidator extends Validators {
  static validate(control: FormControl): ValidationErrors | null {
    let result = null;

    if (control.value?.match(validCharacters) === null) {
      result = { pin: true };
    }

    return result;
  }
}
